class ProgramCurriculum {
  constructor(dom) {
    this.NAME = 'ProgramCurriculum';
    this.dom = dom;
  }

  init() {
    this.dom.querySelectorAll('[data-curriculum-term-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () => this.toggle(toggle, '.program-curriculum__term'));
    });

    this.dom.querySelectorAll('[data-curriculum-course-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () => this.toggle(toggle, '.program-curriculum__course'));
    });
  }

  toggle(toggle, selector) {
    const row = toggle.closest(selector);
    if (!row) return;

    const isOpen = row.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }
}

export default ProgramCurriculum;
